import { PaginationState, SortingState } from '@tanstack/react-table';
import { z } from 'zod';

export const WellsFargoFileIngestionSchema = z.object({
    fileIngestionId: z.number(),
    importDate: z.date().nullable(),
	lockboxNumber: z.number().nullable(),
	totalAmount: z.number().nullable(),
	numberOfChecks: z.number().nullable(),
});

export type WellsFargoFileIngestion = z.infer<typeof WellsFargoFileIngestionSchema>;

export const all = async (
    pagination: PaginationState,
    sorting: SortingState = [],
    params: object,
): Promise<{ data: WellsFargoFileIngestion[]; total: number }> => {
    try {
        let queryString = '';
        if (params) {
            const paramsAsString = JSON.stringify(params)
                .replace(/:/g, '=')
                .replace(/,/g, '&')
                .replace(/[{}"]/g, '');

            const searchParams = new URLSearchParams(paramsAsString);
            if (pagination) {
                searchParams.append('pageSize', pagination.pageSize.toString());
                searchParams.append('pageIndex', pagination.pageIndex.toString());
            }
            
            if (sorting.length > 0) {
                searchParams.append('sortBy', sorting[0].id);
                searchParams.append('sortDirection', sorting[0].desc ? 'desc' : 'asc');
            }

            queryString = `?${searchParams.toString()}`;
        }

        const response = await fetch(`/WellsFargo/wells-fargo-transaction-files${queryString}`);

        return await response.json();
    } catch (err) {
        return {
            data: [],
            total: 0,
        };
    }
};

export const downloadFileIngestion = async (
    fileIngestionId: number,
): Promise<Blob> => {
    const response = await fetch(
        `/WellsFargo/wells-fargo-transaction-files/download/${fileIngestionId}`,
        {
            method: 'GET',
        },
    );

    return await response.blob();
};
